/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import ButtonBase from '@material-ui/core/ButtonBase';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'block',
    position: 'relative',
    width: '17.875rem',
    height: '4rem',
    paddingLeft: '3rem',
    paddingRight: '2rem',
    backgroundColor: theme.palette.cardActive,
    boxShadow: '0px 1px 3px rgba(63, 63, 68, 0.15)',
    borderRadius: '.25rem',
  },
  leftIcon: {
    position: 'absolute',
    top: '50%',
    left: '.75rem',
    transform: 'translateY(-50%)',
  },
  rightIcon: {
    position: 'absolute',
    top: '50%',
    right: '.75rem',
    transform: 'translateY(-50%)',
  },
  title: {
    display: 'block',
    fontSize: 'initial', // TODO Globally define buttons as initial font-size? Check designs
    fontWeight: '600',
    textAlign: 'left',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  subtitle: {
    display: 'block',
    fontSize: 'initial',
    color: theme.palette.input,
    textAlign: 'left',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}));

export default function FilesSelectorSelect({ title, subtitle, icon, isOpen, onClick, ariaControls }) {
  const classes = useStyles();

  return (
    <ButtonBase
      className={classes.root}
      aria-label="open"
      aria-haspopup="true"
      onClick={onClick}
      aria-controls={ariaControls}
    >
      {icon ? <div className={classes.leftIcon}>{icon}</div> : null}
      {!icon ? <PictureAsPdfIcon className={classes.leftIcon} fontSize="small" /> : null}
      <span className={classes.title}>{title}</span>
      <span className={classes.subtitle}>{subtitle}</span>
      {isOpen ? <ExpandLess className={classes.rightIcon} /> : <ExpandMore className={classes.rightIcon} />}
    </ButtonBase>
  );
}
